import { createContext, useContext } from "react";
import { ArticleEditorController } from "./articleEditorController";

export const EditorControllerContext = createContext<ArticleEditorController | null>(null);

export const useEditorController = (): ArticleEditorController => {
	const context = useContext(EditorControllerContext);
	if (context === null) {
		throw new Error("useEditorController must be used within an EditorControllerProvider");
	}
	return context;
};
